import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 25"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M20.416 4.848c.57 0 1 .5.77 1.43l-2.79 13.15c-.195.935-.76 1.16-1.54.725L10.2 15.238a.2.2 0 0 1 0-.325l7.685-6.94c.35-.31-.075-.46-.535-.18l-9.645 6.085a.23.23 0 0 1-.2.025L3.41 12.608c-.91-.265-.91-.89.205-1.335L20 4.953a1.1 1.1 0 0 1 .415-.105"
    }, null, -1)
  ])))
}
export default { render: render }